import AbstractWebRtcListenerAction from "./AbstractWebRtcListenerAction";
import AbstractWebRtcCall from "~/ts/library/webRtc/AbstractWebRtcCall";

export default class WebRtcCallNewIceCandidates extends AbstractWebRtcListenerAction {
    getAction(): string {
        return "webRtcCallNewIceCandidates";
    }

    onAction(payload: CometOperatorApplication.WebRtcCallNewIceCandidatesCometMessageOpenApiModel): void {
        let currentCall = AbstractWebRtcCall.getCurrentCall();
        if (currentCall?.getId() == payload.call.id) {
            currentCall.setCallData(payload.call);
            currentCall.receiveIceCandidates(payload.pairId, payload.iceCandidates!);
        }
    }

}